"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SubMenuLink = _interopRequireDefault(require("../../SubMenuLink"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MenuAnimation = _interopRequireDefault(require("../../MenuAnimation"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dependencies

/**
 * Class rendering sub menu flyout.
 */
class SubMenuDrawer extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      subHeight: 0
    };
  }
  /**
   * Build the list of sub menu links.
   * @param {array} list an array of link JSON to render as link components.
   */
  buildSubList(list) {
    if (list) {
      return list.map((listItem, i) => {
        return /*#__PURE__*/_react.default.createElement(_SubMenuLink.default, {
          href: listItem.src,
          isHovered: this.props.isHovered,
          list: list,
          key: i,
          style: {
            color: 'inherit',
            textDecoration: 'underline',
            fontSize: '14px',
            transition: 'background 0.2s ease-in-out',
            padding: this.props.isMobile ? '5px 10px' : '10px 10px 10px 15px',
            display: 'block',
            margin: '0',
            overflow: 'hidden',
            position: 'relative'
          },
          hoverStyles: {
            color: '#fff',
            background: '#555',
            listStyle: 'none',
            fontWeight: '400'
          }
        }, /*#__PURE__*/_react.default.createElement("li", null, listItem.text));
      });
    }
  }
  componentDidMount() {
    this.getHeight();
  }
  componentDidUpdate() {
    this.getHeight();
  }
  getHeight() {
    if (this.div !== undefined) {
      if (this.state.subHeight !== this.div.clientHeight) {
        this.setState({
          subHeight: this.div.clientHeight
        });
      }
      ;
    }
  }
  render() {
    const desktopStyles = {
      position: 'absolute',
      background: '#333333',
      display: 'block',
      // height: this.props.height,
      height: this.props.height > this.state.subHeight ? this.props.height : this.props.subMenuHeight,
      top: '0',
      fontSize: '14px',
      overflow: 'visible'
    };
    const mobileStyles = {
      position: 'relative',
      background: '#222',
      width: 'auto',
      top: '0',
      fontSize: '14px'
    };
    if (!this.props.list) {
      return false;
    } else {
      return /*#__PURE__*/_react.default.createElement(_MenuAnimation.default, {
        animationState: this.props.isMobile ? this.props.isOpen : this.props.isHovered,
        duration: 250,
        styles: this.props.isMobile ? mobileStyles : desktopStyles,
        isMobile: this.props.isMobile,
        subMenuHeight: this.props.subMenuHeight
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "sub-menu-list",
        style: {
          listStyle: 'none',
          margin: '0',
          padding: '0',
          display: 'block'
        },
        ref: div => {
          this.div = div;
        }
      }, this.buildSubList(this.props.list)));
    }
  }
}
exports.default = SubMenuDrawer;
SubMenuDrawer.propTypes = {
  subMenuHeight: _propTypes.default.object,
  listOpen: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  isHovered: _propTypes.default.bool,
  list: _propTypes.default.array,
  isOpen: _propTypes.default.bool,
  height: _propTypes.default.number
};